import { GridItemLayout } from './types'

export const getGridLayout = (): GridItemLayout => {
  return {
    width: 384,
    height: 373,
    marginRight: 73,
    marginBottom: 46,
    maxWidthPercentage: 16,
  }
}
